import { render, staticRenderFns } from "./personnel-training.vue?vue&type=template&id=5ed002c5&scoped=true"
import script from "./personnel-training.vue?vue&type=script&lang=js"
export * from "./personnel-training.vue?vue&type=script&lang=js"
import style0 from "./personnel-training.vue?vue&type=style&index=0&id=5ed002c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed002c5",
  null
  
)

export default component.exports